<template>
  <div class="main-container" style="background-color: #eff5fb">
    <!-- <Nav /> -->
    <div class="title-adauga-produs">
      <h3 style="text-align: center">{{this.Titlu}}</h3>
      <h6 style="text-align: center; color: red;">Aceasta comanda este blocata cat timp aceasta fereastra este activa!</h6>
    </div>
    <!-- <pre>{{this.temp_list}}</pre> -->
    <div class="container-fluid list-container">
      <div class="title">
        <div v-if="editMode === true" class="container-fluid">
          <i
            class="el-icon-back"
            style="
              font-size: 25px;
              position: absolute;
              top: 60px;
              left: 8%;
              color: #6493c2;
              cursor: pointer;
            "
            @click="switch_mode()"
          ></i>
          <div class="category-container">
            <div v-for="prod in temp_produse" :key="prod.Id">
              <el-button @click="add_item(prod)" class="cat-btn" type="primary">
                {{ prod.Nume }}
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="editMode === false" class="category-container">
          <div v-for="cat in Categorii" :key="cat.Id">
            <el-button
              class="cat-btn"
              @click="switch_mode(cat.Id)"
              type="primary"
              >{{ cat.Nume }}</el-button
            >
          </div>
        </div>
        <div class="products-container">
          <div class="product-content">
            <!-- aici vine tabela -->
            <h6 style="text-align: center">{{TextAtentionare}}</h6>
            <table class="table-list">
              <thead>
                <tr>
                  <th>Nume</th>
                  <th style="text-align: right">Pret</th>
                  <th style="text-align: right">Cantitate</th>
                  <th style="text-align: right">Valoare</th>
                </tr>
              </thead>

              <tbody v-for="(product, i) in temp_list" :key="product.Id + i">
                <tr>
                  <td>{{ product.Nume }}</td>
                  <td style="text-align: right">
                    {{ (product.Pret * 1).toFixed(2) }} Ron
                  </td>
                  <td style="text-align: right">
                    <div class="amount-group">
                  <button @click="change_value(product, '-')" class="btn-amount" :disabled="verifica_drept_modificare_produs(product)">-</button>
                   <input class="input-number" v-model="product.Cantitate" type="number" :disabled="verifica_drept_modificare_produs(product)" >
                  <button @click="change_value(product, '+')" class="btn-amount" :disabled="verifica_drept_modificare_produs(product)">+</button>
                    </div>
                  </td>
                  <td style="text-align: right">
                    {{ (product.Valoare * 1).toFixed(2) }} Ron
                  </td>
                
                  <td colspan="2" style="text-align: right">
                    <div
                      style="
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        justify-content: center;
                      "
                    >
                      <el-button
                      rounded
                      :disabled="verifica_drept_modificare_produs(product)"
                        type="danger"
                        @click="delete_item(i)"
                        class="list-btn"
                        icon="el-icon-delete"
                        ></el-button
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="" style="position: absolute; bottom: 0; margin-top: 10px">
        <h4 style="text-align: center">
          Total:
          {{
            temp_list
              .map((prod) => Number(prod.Valoare))
              .reduce((p, i) => p + i, 0)
              .toFixed(2)
          }}
          Ron
        </h4>
        <div class="footer-btn">
          <el-button @click="renunta()"> Renunta </el-button>
          <el-button type="primary" @click="save()">Salveaza</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePage from "@/pages/Admin/BasePage";
import Nav from "@/pages/Service/Devize/Nav.vue";
export default {
  name: "Programare",
  extends: BasePage,
  components: {
    Nav,
  },
  data() {
    return {
      Titlu: "",
      TextAtentionare: "",
      IdProgramare: "",
      Categorii: undefined,
      Produse: undefined,
      Programare: undefined,
      editMode: false,
      temp_produse: undefined,
      // temp_list: [{Id: '', Nume: '', Pret: '', Cantitate: '', Valoare: ''}],
      temp_list: [],
    };
  },

  methods: {

    verifica_drept_modificare_produs(produs){

      return false;

      // if((this.$has_right('Mecanic') && produs.IdSupervizorAdaugare == '-1') ||
      //    (this.$has_right('Supervizor') && produs.IdSupervizorAdaugare > '0'))
      // {
      //   return false;
      //  }
      // return true
    },

    change_value: async function(prod, mode) {

      // console.log(prod)
      if (mode === "+") {
          this.temp_list.find(p => p.Id === prod.Id).Cantitate++;
      } else {
          if (this.temp_list.find(p => p.Id === prod.Id).Cantitate <= 1) return;
          this.temp_list.find(p => p.Id === prod.Id).Cantitate--;
      }
      this.refresh_array(prod);
    },

    add_item: async function (prod) {
    
      if (this.temp_list.find(p => p.Id === prod.Id)) {
        var index = this.temp_list.findIndex(obj => {
          return obj.Id === prod.Id
        })
        this.$set(this.temp_list[index], 'Cantitate', Number(this.temp_list[index].Cantitate) + 1)
        this.$set(this.temp_list[index], 'Valoare', this.temp_list[index].Cantitate * this.temp_list[index].Pret)
        this.temp_list.splice( this.temp_list.length)
      } else {
        prod.Cantitate = 1;
        prod.Valoare   = prod.Pret;
        this.temp_list.unshift(prod);
      }

    },

    refresh_array: async function (product) {
      // console.log(product)
      if (product.Cantitate === "" || product.Cantitate.length < 0 || product.Cantitate < 0) product.Cantitate = 1;
      product.Valoare = product.Pret * product.Cantitate;
      this.temp_list.splice( this.temp_list.length);
    },
    delete_item: async function (index) {
      this.temp_list.splice(index, 1);
    },

    save: async function () {
      let res = await this.post("service/devize/save_produse_programare_deviz", {produse: this.temp_list, IdProgramare: this.IdProgramare});
      if(res.success == 1) {
        this.$message({ message: 'Devizul a fost salvat!', type: 'success' });
        this.$router.push({name: 'rezervari'})
      } else {
        this.$message({ message: res.eroare, type: 'error' });  
      }

      // if(this.$has_right('Mecanic')) this.$router.push({name: 'devize_draft'})
      // if(this.$has_right('Supervizor')) this.$router.push({name: 'devize_in_lucru'})

      // this.$router.push({name: 'devize_draft'})
      

    },

    renunta: async function () {
      this.$router.push({name: 'rezervari'})
    },

    switch_mode: async function (id) {
      if (!id) {
        this.temp_produse = undefined;
      } else {
        let res = await this.post("admin/produse/get_info_from_category", {  idCategorie: id, IdProgramare: this.IdProgramare});
        let results = res.Result;
        this.temp_produse = results;
        // console.log(this.temp_produse);
      }

      this.editMode = !this.editMode;
    },
    deblocare_programare: async function(){
      let res = await this.post("service/devize/deblocare_programare", {IdProgramare: this.IdProgramare});
      if(res.success == 1) this.$message({ message: 'Programarea a fost deblocata!', type: 'success' });
    },    
    
  },

  mounted: async function () {

    // if (!this.$has_right('Mecanic') && !this.$has_right('Supervizor')){
    //   this.$router.push('/no-rights')
    //   return
    // }

    this.IdProgramare = this.$route.params.id_programare;
    let categorii = await this.post("categorii_produse/get_info_deviz", {IdProgramare: this.IdProgramare});
    this.Categorii = categorii.Result;
    this.Titlu = '#'+this.IdProgramare+" - "+categorii.client.Nume+ " "+categorii.client.Prenume;
    
    let produse_existente_deviz = await this.post("service/devize/get_produse_programare_deviz", {IdProgramare: this.IdProgramare});
    if(produse_existente_deviz.eroare){
      await this.$confirm(`Doriti preluarea fortata? Este posibil ca utilizatorul sa nu fi salvat progresul`, produse_existente_deviz.eroare, {
        confirmButtonText: 'Da',
        cancelButtonText: 'Nu',
        type: 'warning'
      }).then (async() => {
        let preluat = await this.post("service/devize/preluare_fortata", {IdProgramare: this.IdProgramare});
        
        if(preluat.success){
          let produse_existente_deviz = await this.post("service/devize/get_produse_programare_deviz", {IdProgramare: this.IdProgramare});
          this.temp_list = [];
          if(produse_existente_deviz.produse_actualizate > 0) this.$message({ message: 'Au fost actualizate preturile pentru '+ produse_existente_deviz.produse_actualizate + ' produse', type: 'success' });
          this.temp_list = produse_existente_deviz.Produse;
          await this.$message({
            type: 'success',
            message: 'Preluare fortata!'
          });

        } else {
          await this.$message({
            type: 'error',
            message: preluat.error
          });
        }
        
      }).catch( async() => {
        await this.$message({
          type: 'info',
          message: 'Preluare anulata'
        });        
        this.$router.push({name: 'rezervari'})
      });
    } else { 
      if(produse_existente_deviz.produse_actualizate > 0) this.$message({ message: 'Au fost actualizate preturile pentru '+ produse_existente_deviz.produse_actualizate + ' produse', type: 'success' });
      this.temp_list = produse_existente_deviz.Produse;
      this.TextAtentionare = produse_existente_deviz.tip;
    }
  },
  async beforeRouteLeave (to, from, next) {
    await this.deblocare_programare();
    next()
  },
  async beforeDestroy() {
    await this.deblocare_programare();
	}
};
</script>

<style scoped>
.table-list {
  margin: 0;
  padding: 0;
  width: 100%;
}

.main-container {
  max-height: 100vh;
  overflow: hidden;
}

.list-btn {
  width: 70px;
  padding: 3px 15px;
  text-align: center;
  font-size: 10px;
  height: 21px;
}

.category-container {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 16vh;
  overflow: hidden;
  overflow-y: scroll;
}
.list-container {
  margin: 0;
  padding: 15px 5px;
  width: 100% !important;

  display: flex;
  justify-content: center;
  background-color: #eff5fb;
  gap: 4px;
  flex-wrap: wrap;
  overflow: hidden;
  overflow-y: scroll;
  min-height: 100vh;
}

.products-container {
  position: relative;
  margin: 0;
  padding: 10px;
  width: 80%;
  max-height: 50vh;
  overflow: scroll;
  margin-top: 50px;
  border-radius: 4px;
  background-color: #dde9f5;
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 1.1rem;
}

.product-content {
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  background-color: #dde9f5;
  max-height: 100%;
}

.product-title {
  height: 50px;
  border-bottom: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  width: 100%;
  height: 10vh;
}

.title-adauga-produs {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}

.cat-btn {
  background-color: #6493c2;
  border-color: #6493c2;
  min-width: 25vw;
  height: 32px;
  margin: 0px;
  padding: 7px;
  font-size: 1.0rem;
}



.footer-container {
  min-height: 100%;
  margin: 0;
  padding: 0;
  width: 80%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.amount-group {
  height: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

}

.btn-amount {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 17px;
  border: none;
  width: 22px;
  background-color: transparent;
}

.input-number {
  background: transparent;
  text-align: center;
  width: 15%;
  font-size: 15px;
  height: 100%;
  border: none;
  padding: 0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input:focus {
    outline: none !important;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media only screen and (max-width: 700px) {
  /* Pentru telefon: */

  .input-number {
    width: 30%;

  }

  .btn-amount {
    font-size: 15px;
    width: 20px;

  }

  .main-container {
    max-height: 100vh;
    overflow: hidden;
  }

  .footer-container {
    width: 86%;
  }

  .list-container {
    max-height: 90vh;
  }

  .title {
    width: 100%;
    height: 10vh;
  }

  .category-container {
    position: relative;
    display: flex;
    justify-content: space-evenly;
    max-height: 15vh;
  }
  .products-container {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-height: 40vh;
    overflow: auto;
    width: 90%;
    font-size: 0.9rem;
  }

  .footer-btn {
    margin: 0;
    padding: 0;
    justify-content: center;
  }

  .footer-btn .el-button {
    width: 100px;
    text-align: center;
    font-size: 10px;
  }

  .cat-btn {
    text-align: center;
    background-color: #6493c2;
    border-color: #6493c2;
    width: 40vw;
    min-height: 42px;
    height: auto;
    font-size: 3.5vw;
    white-space: normal;
    word-wrap: break-word;
  }
}

.footer-btn {
  display: flex;
  justify-content: center;
  margin-bottom: 15px !important;
}


</style>